import React from 'react';
import ForgetPassword from '../ForgotPasswordFlow/index';
import ForgotPasswordRM from '../../Employee/ForgotPassword/index';
import Helmet from 'react-helmet';
import { siteTitle,faviconURL } from '../../../../data/SiteConfig';

import RegistrationPage from '../../../components/RegistrationPage/RegistrationPage';

export default function RegistrationHomePage(props) {
  return (
      <RegistrationPage>
        <Helmet title={`Forgot Password | ${siteTitle}`}></Helmet>
        <link rel="icon" href={faviconURL} type="image/icon type"/>
        {props.user==='rm'?<ForgotPasswordRM />:<ForgetPassword />}
      </RegistrationPage>
  );
}
